import React, { useEffect, useState } from "react";
import CompanyLinkForm from "../../../components/CompanyLinks/CompanyLinkForm";
import { useSession } from "../../../context/SessionContext";
import { useCompanies } from "../../../hooks/useCompanies";
import { t } from "../../../i18n";
import { Company } from "../../../types/company.types";
import { LinkedList } from "./LinkedList";

// Empresas de OPME vinculadas ao médico.
export const CompanyLinks: React.FC = () => {
  const { listMyCompanies, unlinkCompany, unlinking } = useCompanies();
  const { setMetadata } = useSession();
  const [companies, setCompanies] = useState<Company[]>([]);
  const [loadingList, setLoadingList] = useState(true);

  useEffect(() => {
    listMyCompanies().then((result) => {
      if (result) setCompanies(result.companies);
      setLoadingList(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleUnlink = async (company: Company) => {
    if ((await unlinkCompany(company.id)) === null) return;
    setCompanies((prev) => prev.filter((c) => c.id !== company.id));
    // Mantém `metadata.companies` (lido por outras telas) igual ao que foi desvinculado aqui.
    setMetadata((prev) => ({ ...prev, companies: prev.companies.filter((c) => c.id !== company.id) }));
  };

  return (
    <LinkedList
      items={companies}
      loading={loadingList}
      loadingText={t("links.company.loading")}
      emptyText={t("links.company.empty")}
      unlinkTitle={t("links.company.unlinkTitle")}
      subtitle={(c) => [c.cnpj, c.phone, c.email].filter(Boolean).join(" · ")}
      busy={unlinking}
      onUnlink={handleUnlink}
      addForm={
        <CompanyLinkForm existingCompanies={companies} onLinked={(company) => setCompanies((prev) => [...prev, company])} />
      }
    />
  );
};
